import React from 'react';
import { CalendarIcon, ClockIcon, UserIcon, VideoCameraIcon } from '@heroicons/react/24/outline';

interface UpcomingClassCardProps {
  id: string;
  courseTitle: string;
  batchName?: string;
  instructor: string;
  date: string;
  time: string;
  duration: string;
  isLive: boolean;
  zoomLink?: string;
}

export default function UpcomingClassCard({
  courseTitle,
  batchName,
  instructor,
  date,
  time,
  duration,
  isLive,
  zoomLink
}: UpcomingClassCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
      {/* Header with Live Badge */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h4 className="font-semibold text-gray-900 mb-1 line-clamp-1">{courseTitle}</h4>
          {batchName && (
            <p className="text-xs text-blue-600 font-semibold">{batchName}</p>
          )}
        </div>
        {isLive && (
          <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded border border-red-200 flex items-center gap-1">
            <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
            LIVE
          </span>
        )}
      </div>

      {/* Class Details */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <UserIcon className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">{instructor}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <CalendarIcon className="w-4 h-4 flex-shrink-0" />
          <span>{date}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <ClockIcon className="w-4 h-4 flex-shrink-0" />
          <span>{time}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <ClockIcon className="w-4 h-4 flex-shrink-0" />
          <span>Duration: {duration}</span>
        </div>
      </div>

      {/* Action Button */}
      {zoomLink ? (
        <a
          href={zoomLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-center flex items-center justify-center gap-2"
        >
          <VideoCameraIcon className="w-5 h-5" />
          {isLive ? 'Join Now' : 'Join Class'}
        </a>
      ) : (
        <button
          disabled
          className="w-full px-4 py-2 bg-gray-200 text-gray-500 rounded-lg cursor-not-allowed font-medium text-center"
        >
          Link Not Available
        </button>
      )}
    </div>
  );
}